import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../promo-code-list/model/promo-code-list.constants";
import PromoCodeCreateTemplateComponent from "./promo-code-create.template.component";
import { getPromoCodeInputs } from "../model/promo-code.modal";
import { createPromoCode } from "./promo-code-create.component.service";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PROMOCODE_ALERTS: {CREATE_ALERT}
} = MESSAGES;

const PromoCodeCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let PromoCodePayload = {};
    for (let i = 0; i < values.length; i++) {
        PromoCodePayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const promoCodeResponse = await createPromoCode(PromoCodePayload);

    // INFO : check api response and show relevant alert message
    if (promoCodeResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: promoCodeResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getPromoCodeInputs({}),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <PromoCodeCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default PromoCodeCreateComponent;